export default "__VITE_ASSET__BJ7sKUAE__"